/* 🤖 this file was generated by svg-to-ts */
export const matIconLiveTv: {
  name: 'live-tv';
  data: string;
} = {
  name: 'live-tv',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 10v8l7-4zm12-4h-7.58l3.29-3.29L16 2l-4 4h-.03l-4-4-.69.71L10.56 6H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14H3V8h18v12z"/></svg>`
};
